import * as React from 'react';
import classNames from 'classnames';

import {UnsavedChangesNoticePopupMountPoint} from './unsaved_changes/UnsavedChangesNoticePopup';

import styles from './PageContent.module.css';

interface PageContentProps {
  children: React.ReactNode;
  className?: string;
}

// This id is used by the Algolia Crawler to determine what sections of the current page contain
// information that we want parse as searchable content. Specifically we have this
// here to help us differentiate between content relevant to the current page compared to the
// ancillary content that is rendered _around_ the page, like the navigational sidebar and header
const ALGOLIA_SEARCH_INDEX_CRAWLER_ID_REF = 'algolia-crawler--page-content-container';

export default function PageContent({children, className}: PageContentProps) {
  return (
    <main id={ALGOLIA_SEARCH_INDEX_CRAWLER_ID_REF} className={classNames(styles.contentWrapper, className)}>
      {children}
      <UnsavedChangesNoticePopupMountPoint />
    </main>
  );
}
